import { render } from "./RfInicio.vue?vue&type=template&id=000463cc"
import script from "./RfInicio.vue?vue&type=script&lang=js"
export * from "./RfInicio.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__